import { Select } from "@fluentui/react-components";
import { userRoleEnum } from "../../../../utils/enums";
import { useContext } from "react";
import UserContext from "../../../../modules/AppRouter/UserContext";
import "./UserRoleSelect.css";
import { useHistory, useLocation } from "react-router-dom";

interface IAppDialogProps {
    setWorkContext: React.Dispatch<React.SetStateAction<string | null>>;
    workContext: string | null;
}

const UserRoleSelect: React.FC<IAppDialogProps> = ({
    setWorkContext,
    workContext
}) => {
  const { userData, setUserData } = useContext(UserContext);
  const history = useHistory();
  const location = useLocation();

  const options = [
    { key: "admin-option", value: userRoleEnum.Admin, label: "Administrator" },
    { key: "manager-option", value: userRoleEnum.Manager, label: "Kierownik" },
    { key: "employee-option", value: userRoleEnum.Employee, label: "Pracownik" },
  ];

  const filteredOptions = options.filter((option) =>
    userData.data.roles.includes(option.value),
  );

  const selectedRole =
    workContext && filteredOptions.some((option) => option.value === workContext)
      ? workContext
      : (filteredOptions[0]?.value ?? userRoleEnum.Employee);

  const handleRoleChange = async (roleChangeEvent: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedRole = roleChangeEvent.target.value;
    localStorage.setItem("workContext", selectedRole);
    setWorkContext(selectedRole)
    
    let newUserData = { ...userData };
    newUserData.data.baseRole = selectedRole;
    setUserData(newUserData);

    if (selectedRole === userRoleEnum.Manager) {
      history.push("/resource-allocation");
      return;
    }

    if (location.pathname.startsWith("/resource-allocation")) {
      history.replace("/resource-allocation");
    }

    history.push("/");
  };

  return <>
    <div className="select-role-container">
      <span className="role-label">Rola:</span>
      <Select
        id={"user-role-select"}
        value={selectedRole}
        onChange={handleRoleChange}
      >
        {filteredOptions.map(option => (
          <option key={option.key} value={option.value}>
            {option.label}
          </option>
        ))}
      </Select>
    </div>
  </>
};

export default UserRoleSelect;
